import { render, staticRenderFns } from "./SystemGroup.vue?vue&type=template&id=66e7b009&scoped=true&"
import script from "./SystemGroup.vue?vue&type=script&lang=js&"
export * from "./SystemGroup.vue?vue&type=script&lang=js&"
import style0 from "./SystemGroup.vue?vue&type=style&index=0&id=66e7b009&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e7b009",
  null
  
)

export default component.exports